import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, Feed, Header, Button } from 'semantic-ui-react'
import ActivityActions from 'Redux/ActivityRedux'
import { ComponentsMap } from './ActivityPartials'
import styles from './ListStyles'

class ActivitiesList extends PureComponent {

  constructor(props) {
    super(props)
  
    this.state = {
      page: 1,
      per_page: 10
    }
  }

  componentDidMount() {
    this.props.activitiesListRequest(this.state)
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.page !== prevState.page) {
      this.props.activitiesListRequest(this.state)
    }
  }

  loadMore = () => {
    this.setState(prevState => ({
      page: prevState.page + 1
    }))
  }

  render () {
    return (
      <Container className={styles.container}>
        <Header as='h2' className={styles.header}>
          Recent Activity
        </Header>
        <Feed>
          {this.props.activities.map(activity => {
            const FeedEvent = ComponentsMap[activity.trackableType]
            return <FeedEvent activity={activity} key={activity.id} />
          })}
        </Feed>
        { !this.props.allLoaded &&
          <Button
            loading={this.props.fetching}
            onClick={this.loadMore}
            basic>
              Load More
          </Button>
        }
      </Container>
    )
  }

}

const mapStateToProps = (state) => ({
  activities: state.activities.listData,
  fetching: state.activities.listFetching,
  allLoaded: state.activities.allLoaded,
})

const mapDispatchToProps = (dispatch) => ({
  activitiesListRequest: (params) =>
    dispatch(ActivityActions.activitiesListRequest(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesList)



// WEBPACK FOOTER //
// ./src/Pages/Activities/List.js